import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SetProductComponent} from "./set-product/set-product.component";
import {SignupComponent} from "./signup/signup/signup.component";
import {ReviewComponent} from "./review/review/review.component";
import {ProcessComponent} from "./process/process.component";
import {
  BANKING_CENTER_ENTRY_PATH,
  BANKING_CENTER_PRODUCT_PATH,
  BRANCH_PATH,
  CODE_VERIFICATION_PATH, INVITATION_CREATION_PATH,
  CREATE_LOGIN_PATH,
  ERROR_PATH,
  HOME_PATH,
  INVITATION_PATH,
  JOINT_MAINTENANCE_CREATE_LOGIN_PATH,
  JOINT_MAINTENANCE_APPLICATION_PATH,
  MAINTENANCE_PATH,
  PROCESSING_PATH,
  PRODUCT_PATH,
  REVIEW_PATH,
  SECURE_SESSION_ID_URL_PARAM_NAME,
  SUCCESS_PATH, INVITATION_CREATION_REVIEW_PATH, ALLOY_SDK_PATH, PAGE_BREAK_PATH, JOINT_MAINTENANCE_PAGE_BREAK_PATH, SELECT_ACCOUNTS_PATH,
  TERMS_AND_DISCLOSURES_PATH,
  FUNDING_PATH
} from "./shared/constants";
import {ErrorComponent} from "./error/error.component";
import {SuccessComponent} from "./success/success.component";
import {CodeVerificationComponent} from "./signup/code-verification/code-verification.component";
import {ExistingAppGuard} from "./guards/existing-app.guard";
import {SecureSessionGuard} from "./guards/secure-session.guard";
import {ProductGuard} from "./guards/product.guard";
import {InternalRoutingGuard} from "./guards/internal-routing.guard";
import { CatalogDataResolver } from "./core/resolvers/catalog-data.resolver";
import { MaintenanceComponent } from './maintenance/maintenance.component';
import {BackButtonGuard} from "./guards/back-button.guard";
import {BankingCenterComponent} from "./banking-center/banking-center.component";
import {BranchComponent} from "./branch/branch.component";
import {
  JointApplicationComponent
} from "./joint-application-maintenance/joint-application/joint-application.component";
import {InvitationLandingPageComponent} from "./joint-application-maintenance/invitation/invitation-landing-page/invitation-landing-page.component";
import {LoginDetailsComponent} from "./login-details/login-details.component";
import {
  CreateInvitationComponent
} from "./joint-application-maintenance/invitation/create-invitation/create-invitation.component";
import {
  ReviewCreatedInvitationComponent
} from "./joint-application-maintenance/invitation/create-invitation/review-created-invitation/review-created-invitation.component";
import { ProductInitResolver } from './core/resolvers/product-init.resolver';
import {ManualRoutingGuard} from "./guards/manual-routing-guard";
import { CompanyIdentifierComponent } from './employee-benefit/company-identifier/company-identifier.component';
import { ProductSelectionComponent } from './employee-benefit/product-selection/product-selection.component';
import { GlobalSettingsResolver } from './core/resolvers/global-settings.resolver';
import {VerificationInitResolver} from "./core/resolvers/verification-init.resolver";
import {AlloySdkFrameComponent} from "./shared/components/alloy-sdk-frame/alloy-sdk-frame.component";
import { PageBreakComponent } from './shared/components/page-break/page-break.component';
import { SelectAccountsComponent } from './signup/select-accounts/select-accounts.component';
import { ViewDisclosuresComponent } from './review/view-disclosures/view-disclosures.component';
import { FundingComponent } from './shared/components/funding/funding.component';

const routes: Routes = [
  {path: "employee-benefit/access",
   component: CompanyIdentifierComponent },
   {path: "employee-benefit/products",
   component: ProductSelectionComponent },
  {path: SELECT_ACCOUNTS_PATH, component: SelectAccountsComponent, canActivate: [ManualRoutingGuard]},
  {path: HOME_PATH, component: SignupComponent, resolve: { catalogs: CatalogDataResolver }, canActivate: [InternalRoutingGuard, ExistingAppGuard, ManualRoutingGuard]},
  {path: REVIEW_PATH, component: ReviewComponent, resolve: { catalogs: CatalogDataResolver }, canActivate: [InternalRoutingGuard, ExistingAppGuard, ManualRoutingGuard]},
  {path: TERMS_AND_DISCLOSURES_PATH, component: ViewDisclosuresComponent, resolve: { catalogs: CatalogDataResolver }, canActivate: [InternalRoutingGuard, ExistingAppGuard, ManualRoutingGuard]},
  {path: PROCESSING_PATH, component: ProcessComponent, canActivate: [InternalRoutingGuard, ExistingAppGuard, ManualRoutingGuard]},
  {path: ERROR_PATH, component: ErrorComponent, canActivate: [InternalRoutingGuard, ExistingAppGuard]},
  {path: PRODUCT_PATH, component: SetProductComponent, resolve: { init: ProductInitResolver }, canActivate: [ProductGuard, ManualRoutingGuard]},
  {path: SUCCESS_PATH, component: SuccessComponent, canActivate: [InternalRoutingGuard, ExistingAppGuard]},
  {path: HOME_PATH, redirectTo: '/apply', pathMatch: 'full'},
  {path: PRODUCT_PATH, redirectTo: '/apply', pathMatch: 'full'},
  {path: BANKING_CENTER_ENTRY_PATH, component: BankingCenterComponent},
  {path: BANKING_CENTER_PRODUCT_PATH, component: BankingCenterComponent, canActivate: [SecureSessionGuard]},
  {path: MAINTENANCE_PATH, component: MaintenanceComponent, resolve: { globalSettings: GlobalSettingsResolver }},
  {path: BRANCH_PATH, component: BranchComponent},
  {path: ALLOY_SDK_PATH, component: AlloySdkFrameComponent, canActivate : [SecureSessionGuard]},
  {path: CREATE_LOGIN_PATH, component: LoginDetailsComponent, canActivate: [InternalRoutingGuard, ExistingAppGuard, ManualRoutingGuard]},
  {path: JOINT_MAINTENANCE_APPLICATION_PATH, component: JointApplicationComponent, resolve: { catalogs: CatalogDataResolver }, canActivate: [ExistingAppGuard, ManualRoutingGuard]},
  {path: JOINT_MAINTENANCE_PAGE_BREAK_PATH, component: PageBreakComponent, resolve: { catalogs: CatalogDataResolver }, canActivate: [ExistingAppGuard, ManualRoutingGuard]},
  {path: INVITATION_PATH, component: InvitationLandingPageComponent, canActivate: [InternalRoutingGuard, BackButtonGuard, ManualRoutingGuard]},
  {path: INVITATION_CREATION_PATH, component: CreateInvitationComponent, canActivate: [InternalRoutingGuard, ExistingAppGuard]},
  {path: INVITATION_CREATION_REVIEW_PATH, component: ReviewCreatedInvitationComponent, canActivate: [InternalRoutingGuard, ExistingAppGuard]},
  {path: JOINT_MAINTENANCE_CREATE_LOGIN_PATH, component: LoginDetailsComponent, canActivate: [InternalRoutingGuard, ExistingAppGuard]},
  {path: PAGE_BREAK_PATH, component: PageBreakComponent, resolve: { catalogs: CatalogDataResolver } , canActivate: [InternalRoutingGuard, ExistingAppGuard, ManualRoutingGuard]},
  {path: FUNDING_PATH, component: FundingComponent, resolve: { catalogs: CatalogDataResolver }, canActivate: [InternalRoutingGuard, ExistingAppGuard, ManualRoutingGuard]},
  {
    path: `${CODE_VERIFICATION_PATH}/:${SECURE_SESSION_ID_URL_PARAM_NAME}`,
    component: CodeVerificationComponent,
    canActivate: [BackButtonGuard],
    resolve: { init: VerificationInitResolver }
  },
  { path: '**', redirectTo: '/apply', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
